var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPhaseIconL3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 184.56 184.56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#95a5a6;}.cls-2,.cls-3{fill:#fff;}.cls-3{opacity:0.5;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_2",
    "data-name": "Ebene 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ebene_1-2",
    "data-name": "Ebene 1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 184.56,
    height: 184.56
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M65.12,115.51H90.78v11.34H50.38V65.71H65.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M110.05,90.36h6.67q7.94,0,7.94-7.77a6.71,6.71,0,0,0-1.89-4.93,7.14,7.14,0,0,0-5.33-1.91,7.65,7.65,0,0,0-4.89,1.63,5,5,0,0,0-2.08,4.08H96.31A14.5,14.5,0,0,1,99,72.85a17.71,17.71,0,0,1,7.46-5.9,25.51,25.51,0,0,1,10.47-2.12q10.21,0,16,4.66t5.84,12.81a12.91,12.91,0,0,1-2.41,7.45,17.16,17.16,0,0,1-7,5.69,16.51,16.51,0,0,1,7.65,5.35,14.18,14.18,0,0,1,2.77,8.89,15.79,15.79,0,0,1-6.3,13.1q-6.3,4.91-16.55,4.91a27.06,27.06,0,0,1-11.15-2.29A17.47,17.47,0,0,1,98,119.06a16.5,16.5,0,0,1-2.64-9.22h14.23a6.37,6.37,0,0,0,2.27,4.87,8,8,0,0,0,5.59,2.06,8.36,8.36,0,0,0,6-2.08,6.94,6.94,0,0,0,2.23-5.31c0-3.08-.78-5.26-2.31-6.55a9.66,9.66,0,0,0-6.39-1.93h-6.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M134.56,33.37h0a5,5,0,0,1-4.95-5V0h9.93l0,28.4A5,5,0,0,1,134.56,33.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M153.06,33.37h0a5,5,0,0,1-5-5V0H158l0,28.4A5,5,0,0,1,153.06,33.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M171.56,33.37h0a5,5,0,0,1-5-5V0h9.93v28.4A5,5,0,0,1,171.56,33.37Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhaseIconL3);
export default __webpack_public_path__ + "static/media/PhaseIconL3.ce5f29433321d2508780a5255dea94c3.svg";
export { ForwardRef as ReactComponent };